import { useContext } from 'react';

import UsersFilter from '@atom/components/common/usersFilter/UsersFilter';
import { Icon } from '@atom/mui';
import { PeopleIcon } from '@atom/mui/icons';

import TeamAssignedToFilter from './TeamAssignedToFilter';
import WorkOrdersFiltersContext from './WorkOrdersFiltersContext';

import classes from './filters.module.css';

const TeamFiltersSection = () => {
  const { filterForm, areFiltersDisabled, updateFilterForm } = useContext(
    WorkOrdersFiltersContext,
  );

  const { teamCompletedByIds, teamCreatedByIds } = filterForm;

  return (
    <div className={classes.filterSection}>
      <div className={classes.filterSectionHeader}>
        <Icon icon={PeopleIcon} />
        Team
      </div>
      <div className={classes.filterContainer}>
        <TeamAssignedToFilter />
      </div>
      <div className={classes.filterContainer}>
        <UsersFilter
          disabled={areFiltersDisabled}
          placeholder="Search for user"
          label="Completed By"
          value={teamCompletedByIds}
          updateValue={updatedFilter =>
            updateFilterForm('teamCompletedByIds', updatedFilter)
          }
          dataCy="workOrdersFilterCompletedByInput"
        />
      </div>
      <div className={classes.filterContainer}>
        <UsersFilter
          disabled={areFiltersDisabled}
          placeholder="Search for user"
          label="Created By"
          value={teamCreatedByIds}
          updateValue={updatedFilter =>
            updateFilterForm('teamCreatedByIds', updatedFilter)
          }
          dataCy="workOrdersFilterCreatedByInput"
        />
      </div>
    </div>
  );
};

export default TeamFiltersSection;
